import { ComponentChildren } from 'preact';
import { createPortal } from 'preact/compat';
import { useUniqueId } from 'utilities/use-unique-id';

import { usePortalsManager } from 'components/PortalsManager';

interface PortalProps {
  children?: ComponentChildren;
}

export function Portal({ children }: PortalProps) {
  const { container } = usePortalsManager();
  const id = useUniqueId('Portal');

  return container
    ? createPortal(<div id={id}>{children}</div>, container)
    : null;
}
